import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CentralSkuComboService } from '@api/services/global/central-sku-combo.service';
import { ComboService } from '@api/services/global/combo.service';
import { DynamicFormService } from '@api/services/dynamic-form.service';
import { WorkflowStatusService } from '@api/services/workflow-status.service';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { SelectModule } from 'primeng/select';
import { SisAutocompleteComponent } from './components/sis-autocomplete/sis-autocomplete.component';
import { SisDropdownComponent } from './components/sis-dropdown/sis-dropdown.component';

@NgModule({
	declarations: [SisDropdownComponent, SisAutocompleteComponent],
	imports: [CommonModule, FormsModule, SelectModule, AutoCompleteModule],
	exports: [SisDropdownComponent, SisAutocompleteComponent],
	providers: [ComboService, CentralSkuComboService, WorkflowStatusService, DynamicFormService],
})
export class SisDropdownModule {}
